<template>
    <div>
        <HeaderBar/>
    <!-- search input -->

    <div class="d-flex justify-content-center mt-1 headTitle mt-4">
      Salida de animal
    </div>
    <div class="d-flex justify-content-center mt-1 headTitle">
      {{fincaName}}
    </div>
        <div class="d-flex flex-column justify-content-center px-1">
            <validation-observer>
                <b-form>
                    <b-form-group class="datePicker">
                        <h5 class="font-weight-bold ">
                            Fecha
                        </h5>
                        <b-form-datepicker id="fecha_compra" name="fecha_compra" v-model="animal_exits.date" 
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        :min="minCfgDate" :max="maxCfgDate"
                        locale="es-ES"/>
                    </b-form-group>
                    
                    <b-form-group>
                        <v-select placeholder="Buscar y seleccionar Animal"  v-model="animal_exits.animal_id" :options="animalsOptions"  :value="animalsOptions.value" label="text" />
                    </b-form-group>
                    <div class="d-flex ">
                    <b-form-group label="Motivo de salida:" label-for="reasonOfExit" class="flex-fill mr-1">
                        <b-form-select  id="reasonOfExit" placeholder="Venta" v-model="animal_exits.reason" :options="reasonOfExitOptions"  :value="reasonOfExitOptions.text" label="text" />
                    </b-form-group>
                    <b-form-group label="Peso(Opcional)" label-for="weight" class="flex-fill">
                        <validation-provider #default="{ errors }" name="weight" rules="required">
                            <b-form-input id="weight" v-model="animal_exits.weight" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    </div>
                    <div class="d-flex">
                        <b-form-group label="Descripción" label-for="description" class="flex-fill" >
                           <validation-provider name="description" rules="required">
                            <b-form-input id="description" v-model="animal_exits.description"/>
                           </validation-provider>
                        </b-form-group>
                        <!-- <div class="ml-1">Subir archivo o foto:</div>
                        <b-img src="@/assets/images/ganImage/UpoladImage.png"></b-img> -->
                    </div>
<!--                     <div class="d-flex">
                    <b-img src="@/assets/images/ganImage/income-ecoValue.png" class="flex-fill"></b-img>
                    </div> -->
                    <div v-if="exit_reason=='Venta'">
                        <b-form-group label="Lugar de Venta" label-for="salesPlace">
                            <v-select id="salesPlace" placeholder="Subasta" v-model="animal_exits.salesPlace" :options="salesPlaceOptions" label="text" />
                        </b-form-group>
                       <!--  <b-form-group label="Motivo de Venta" label-for="reasonSale">
                            <b-form-select  id="reasonSale" v-model="animal_exits.reasonSale" :options="reasonSaleOptions" label="text" />
                        </b-form-group> -->
                        <div class="d-flex justify-content-center flex-column">

                            <div class="d-flex ">
                        
                            <b-form-group label="Valor de Venta" label-for="saleValue" class="mr-1">
                                <validation-provider #default="{ errors }" name="date" rules="required">
                                    <b-form-input id="saleValue" v-model="animal_exits.saleValue" :state="errors.length > 0 ? false : null"
                                        name="saleValue" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label="Comisión Subasta" label-for="auctionCommission" v-if="sale_place=='Subasta'">
                                <validation-provider #default="{ errors }" name="auctionCommission" rules="required">
                                    <b-form-input id="auctionCommission" v-model="animal_exits.auctionCommission" :state="errors.length > 0 ? false : null"
                                        name="auctionCommission" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                        </div></div>
                    </div>
                    <div class="d-flex justify-content-center ">
                        <b-button  class="bg-primary w-75" @click="insertExit()">
                            <div class="d-flex justify-content-center ">
                                Incluir evento
                            </div>
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </div>
        <ControlMenu />
    </div>
</template>

<script>
import HeaderBar from '@/components/HeaderBar.vue'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import flatPickr from 'vue-flatpickr-component'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BFormDatepicker, BLink, BImg, BFormGroup, BForm, BButton, BFormSelect, BFormInput, BFormCheckboxGroup,BFormCheckbox, BFormTextarea } from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
import { required } from '@validations'
export default {
    components: {
    BFormGroup,
    flatPickr,
    BFormCheckboxGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    required,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormSelect,
    BFormInput,
    BFormDatepicker,
    ControlMenu,
    BFormCheckbox,
    BFormTextarea,
    ControlMenu,
    HeaderBar,
},
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 11)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate())
        return {
            fincaName:localStorage.getItem('currentFarmName'),
            dateFormat:'%n/%Y',
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            findSelectOptions:[],
            reasonOfExitOptions:[],
            salesPlaceOptions:[],
            reasonSaleOptions:[],
            animalsOptions:[],
            sale_place:"Subasta",
            exit_reason:'Muerte',
            animal_exits:{
                farm_id:localStorage.getItem('currentFarm'),
                date:null,
                animal_id:null,
                reason:'Muerte',
                weight:null,
                description:null,
                salesPlace:null,
                reasonSale:null,
                saleValue:0,
                auctionCommission:null
            },
            economic:{
                date:null,
                unit:0,
                amount:0,
                voucher_num:'',
                total:0,
                type:1,
                record_type:1,
                product_id:7,
                description:'Venta de Animal',
                farm_id:localStorage.getItem('currentFarm'),
            }
        }
    },

    methods:{
        async fetchExitReasons(config) {
        fetch(this.$apiUrl+"list/exit_reasons", config)
          .then((response) => response.json())
          .then((result) => {
            console.log(result)
            this.reasonOfExitOptions = result.exit_reasons.map((item) =>{ return {value:item.name,text:item.name}})
          }) 
          .catch((error) => console.log("error", error));
        // ------
      },

      async fetchSalesPlace(config) {
        fetch(this.$apiUrl+"list/sale_place", config)
          .then((response) => response.json())
          .then((result) => {
            this.salesPlaceOptions = result.sale_place.map((item) =>{ return {text:item.name}})
          }) 
          .catch((error) => console.log("error", error));
        // ------
      },
      async fetchAnimals(config){
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/animals?recperpage=all&state=1&farm_id="+farmId, config)
        .then((response) => response.json())
        .then((result) => {
          this.animalsOptions = result.animals.map((item) =>{ return { value:item.id, text:item.number+' '+item.name}})
        }) 
        .catch((error) => console.log("error", error));
        // ------
      },
      async insertExit(){
        let self=this;
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        self.animal_exits.animal_id=self.animal_exits.animal_id.value;
        console.log(self.animal_exits);
        self.$http.post("add/animal_exits", self.animal_exits, config).then((result)=>{
            console.log(result);
            if(self.animal_exits.saleValue>0){
                self.economic.amount=self.animal_exits.saleValue;
                self.economic.total=self.animal_exits.saleValue;
                self.economic.date=self.animal_exits.date;
                self.$http.post("add/economic_records", this.economic, config)
            }
            self.$swal({
                title: 'Registro de Animal',
                text: 'Se insertó salida de animal de manera satisfactoria',
                type: 'success',
                icon:'success',
                showCancelButton: false,
                confirmButtonColor:'#5E8F23',
                showCloseButton: true,
                showLoaderOnConfirm: false  
              }).then(function(){
                history.back();
              });
            }).catch(error => {
              console.log(error)
            });
      }
    },
    watch:{
        'animal_exits.reason':function(value){
            console.log(value);
            this.exit_reason= value;
        },
        'animal_exits.salesPlace':function(value){
            console.log(value);
            this.sale_place= value.text;
        }
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchExitReasons(config);
        this.fetchSalesPlace(config);
        this.fetchAnimals(config);
        

}}
</script>


<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
.headTitle {
  font-weight: 600;
  font-size: 24px;
  color: #5E8F23;
}
</style>
